import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNoPatients = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 120.765,
	height: 73.27,
	viewBox: "0 0 23.386 13.954",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsxs("g", {
		id: "Group_364",
		"data-name": "Group 364",
		transform: "translate(-2929.59 -1615.45)",
		children: [
			/* @__PURE__ */ _jsxs("g", {
				id: "Group_361",
				"data-name": "Group 361",
				transform: "translate(2935.681 1616)",
				children: [/* @__PURE__ */ _jsx("circle", {
					id: "Ellipse_123",
					"data-name": "Ellipse 123",
					cx: 3.274,
					cy: 3.274,
					r: 3.274,
					transform: "translate(2.419 0)",
					fill: "none",
					stroke: "#28666c",
					strokeLinecap: "round",
					strokeMiterlimit: 10,
					strokeWidth: 1.1
				}), /* @__PURE__ */ _jsx("path", {
					id: "Path_382",
					"data-name": "Path 382",
					d: "M2973.6,1663.081a3.6,3.6,0,0,0-3.494-2.741h-4.367a3.6,3.6,0,0,0-3.51,2.811,7.76,7.76,0,0,0,11.371-.07Z",
					transform: "translate(-2962.229 -1652.741)",
					fill: "none",
					stroke: "#28666c",
					strokeLinecap: "round",
					strokeMiterlimit: 10,
					strokeWidth: 1.1
				})]
			}),
			/* @__PURE__ */ _jsxs("g", {
				id: "Group_362",
				"data-name": "Group 362",
				transform: "translate(2945.568 1617.542)",
				children: [/* @__PURE__ */ _jsx("circle", {
					id: "Ellipse_124",
					"data-name": "Ellipse 124",
					cx: 2.488,
					cy: 2.488,
					r: 2.488,
					transform: "translate(0 0)",
					fill: "none",
					stroke: "#28666c",
					strokeLinecap: "round",
					strokeMiterlimit: 10,
					strokeWidth: 1.1
				}), /* @__PURE__ */ _jsx("path", {
					id: "Path_383",
					"data-name": "Path 383",
					d: "M3026.382,1662.692a5.884,5.884,0,0,0,4.346-1.91,2.734,2.734,0,0,0-2.655-2.083h-3.319",
					transform: "translate(-3023.924 -1652.923)",
					fill: "none",
					stroke: "#28666c",
					strokeLinecap: "round",
					strokeMiterlimit: 10,
					strokeWidth: 1.1
				})]
			}),
			/* @__PURE__ */ _jsxs("g", {
				id: "Group_363",
				"data-name": "Group 363",
				transform: "translate(2930.19 1617.542)",
				children: [/* @__PURE__ */ _jsx("circle", {
					id: "Ellipse_125",
					"data-name": "Ellipse 125",
					cx: 2.488,
					cy: 2.488,
					r: 2.488,
					transform: "translate(1.839 0)",
					fill: "none",
					stroke: "#28666c",
					strokeLinecap: "round",
					strokeMiterlimit: 10,
					strokeWidth: 1.1
				}), /* @__PURE__ */ _jsx("path", {
					id: "Path_384",
					"data-name": "Path 384",
					d: "M2936.177,1658.7h-3.319a2.734,2.734,0,0,0-2.667,2.136,5.882,5.882,0,0,0,4.3,1.857",
					transform: "translate(-2930.19 -1652.923)",
					fill: "none",
					stroke: "#28666c",
					strokeLinecap: "round",
					strokeMiterlimit: 10,
					strokeWidth: 1.1
				})]
			})
		]
	})]
});
const ForwardRef = forwardRef(SvgNoPatients);
export { ForwardRef as ReactComponent };
